import React from "react";
// Components
import MainTable from '../../Components/Tables/Main/MainTable'
import ButtonSwitchBetweenTables from '../../Components/Buttons/ButtonSwitchBetweenTables'
// Hooks
import { useMaintenanceAlerts } from "../../Hooks/useMaintenanceAlerts";
import { useVehicles } from "../../Hooks/useVehicles";
import { useHistory } from "react-router-dom";
// Constants
import { alertTypes } from "../../CommonConstants";

const AlertsMaintenance = () => {
    const [alertsData, addAlert, updateAlert, deleteAlert] = useMaintenanceAlerts();

    const history = useHistory();

    const navigateToDocumentsAndRemindersAlerts = () => history.push('/alerts')

    let [vehicles] = useVehicles(true);
    vehicles = vehicles.reduce(
        function (acc, cur) {
            const { id, brand, model, patent, year } = cur;
            acc[id] = `${brand} ${model} ${patent} ${year}`;
            return acc;
        },
        {}
    )

    const columns = [
        { title: "Id", field: "id", hidden: true },
        { title: "Tipo", field: "type", lookup: alertTypes.maintenance },
        { title: "Kilómetros entre alertas", field: "kilometersBetween"},
        { title: "Kilómetros de preaviso", field: "kilometersForewarning" },
        { title: "Kilómetros de próxima alerta", field: "kilometersNext", editable: "onAdd" },
        { title: "Vehículo", field: "vehicleId", lookup: vehicles, editable: "onAdd" },
    ];

    return (
        <div>
            <ButtonSwitchBetweenTables text={'Ver alertas de documentos y recordatorio'} onClick={navigateToDocumentsAndRemindersAlerts} />
            <MainTable
                title="Alertas de mantenimiento"
                columns={columns}
                data={alertsData}
                requiredFields={["type", "kilometersBetween", "kilometersForewarning", "kilometersNext", "vehicleId"]}
                deleteText="Se borrará la alerta"
                onRowAdd={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.vehicleId
                    dataToSave.kilometersBetween = +newData.kilometersBetween
                    dataToSave.kilometersForewarning = +newData.kilometersForewarning
                    dataToSave.kilometersNext = +newData.kilometersNext
                    await addAlert(dataToSave, +newData.vehicleId)
                }}
                onRowUpdate={async (newData) => {
                    const dataToSave = { ...newData }
                    delete dataToSave.id
                    delete dataToSave.vehicleId
                    delete dataToSave.kilometersNext
                    dataToSave.kilometersBetween = +newData.kilometersBetween
                    dataToSave.kilometersForewarning = +newData.kilometersForewarning
                    await updateAlert(dataToSave, newData.id)
                }}
                onRowDelete={async (newData) => await deleteAlert(newData.id)}
            />
        </div>)
}

export default AlertsMaintenance


// WEBPACK FOOTER //
// ./src/Containers/AlertsMaintenance/index.js